var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("出单机构")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("统计机构"),
      allowClear: "",
      "show-search": "",
      "filter-option": _vm.filterOption,
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.form.unId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "unId", $$v);
      },
      expression: "form.unId"
    }
  }, _vm._l(_vm.organizationlist, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("保险公司")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保险公司"),
      allowClear: "",
      "show-search": "",
      "filter-option": _vm.filterOption,
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.form.organizationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "organizationId", $$v);
      },
      expression: "form.organizationId"
    }
  }, _vm._l(_vm.organizationlist, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("结算单类型")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("结算单类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.typeId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "typeId", $$v);
      },
      expression: "form.typeId"
    }
  }, _vm._l(_vm.TYPELIST, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("统计月份")
    }
  }, [_c("a-month-picker", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("统计月份"),
      valueFormat: "YYYY-MM",
      allowClear: ""
    },
    model: {
      value: _vm.form.date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "date", $$v);
      },
      expression: "form.date"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.getSearchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    on: {
      click: _vm.handleReport
    }
  }, [_vm._v(_vm._s(_vm.$t("统计报表")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.COLUMNS,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(_vm._s(index + 1))];
      }
    }])
  }, [_vm._l(_vm.COLUMNS, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), _c("template", {
    slot: "保费"
  }, [_vm._v(" (" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + ") ")])], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };